/* eslint-disable import/prefer-default-export */
import { orgCwrUrl } from '../urls';

export async function postOrgCWR(orgId, file) {
  const formData = new FormData();

  formData.append('cwrFile', file);
  formData.append('org', orgId);

  const response = await fetch(orgCwrUrl, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
    },
    body: formData,
  });
  return response;
}

export async function deleteOrgLegacyData(orgId) {
  const data = {
    org: orgId,
  };

  const response = await fetch(orgCwrUrl, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
    },
    body: JSON.stringify(data),
  });
  return response;
}
